import { useCallback, useRef } from "react";

const useThrottledCallback = <T extends (...args: unknown[]) => void>(
    callback: T,
    delay: number,
) => {
    const isCooldown = useRef(false);

    const throttledFn = useCallback(
        (...args: Parameters<T>) => {
            if (isCooldown.current) {
                return;
            }

            callback(...args);
            isCooldown.current = true;

            setTimeout(() => {
                isCooldown.current = false;
            }, delay);
        },
        [callback, delay],
    );

    return throttledFn;
};

export { useThrottledCallback };
